import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import filesKeys from './keyFactory';

const DocumentFormPdfUrl = graphql(`
  query DocumentFormPdfUrl($id: ID!) {
    documentForm(id: $id) {
      __typename
      ... on DocumentFormPdf {
        finalisedPdfUrl
      }
    }
  }
`);

const TWO_MINUTES_MS = 2 * 60 * 1000;

const useGetDocumentFormPdfUrl = (documentId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!documentId,
    queryKey: filesKeys.documentFormPdfUrl(documentId || ''),
    queryFn: () => {
      return gqlClient.request(DocumentFormPdfUrl, { id: documentId || '' });
    },
    staleTime: TWO_MINUTES_MS,
  });

  const documentForm = data?.documentForm;
  const finalisedPdfUrl =
    documentForm?.__typename === 'DocumentFormPdf'
      ? documentForm.finalisedPdfUrl
      : null;

  return { finalisedPdfUrl, data, ...rest };
};

export default useGetDocumentFormPdfUrl;
